// @ts-nocheck

import { createContext } from 'react';

type SportsMenuScrollContextProps = {
  scrollPositions?: { [location: string]: number };
  setScrollPositions?: (newValue: { [location: string]: number }) => void;
};

export const SportsMenuScrollContext = createContext<SportsMenuScrollContextProps>({
  scrollPositions: {},
  setScrollPositions: () => {},
});
